import { storeName } from './constants';

const getModiface = state => state[storeName] || {};

const isLoading = state => getModiface(state).isLoading;
const getStep = state => getModiface(state).step;
const getFaces = state => getModiface(state).faces;
const getFaceId = state => getModiface(state).faceId;
const getFace = state => (getFaces(state) || []).find(({ uid }) => uid === getFaceId(state)) || {};
const getFaceUrl = state => getFace(state).original;
const getMakeupProductData = state => getModiface(state).makeupProductData || [];
const getShades = state => getMakeupProductData(state).map(({ shadeArray }) => shadeArray) || [];
const isLibraryInitialized = state => getModiface(state).isInitialized;
const getSelectedShade = state => getModiface(state).selectedShade || 0;
const getLookObject = state => getShades(state)[getSelectedShade(state)];
const isErrored = state => getModiface(state).isError;
const isLibErrored = state => getModiface(state).isLibError;
const isShadeActive = state => getModiface(state).isShadeActive;

export default {
    isLoading,
    getStep,
    getFaces,
    getFaceId,
    getFace,
    getFaceUrl,
    getShades,
    getMakeupProductData,
    isLibraryInitialized,
    getSelectedShade,
    getLookObject,
    isErrored,
    isLibErrored,
    isShadeActive,
};
